import { NgClass, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  UntypedFormArray,
  UntypedFormGroup,
} from '@angular/forms';
import { SiteSvgsComponent } from '@curbnturf/custom-svgs/src/lib/site-svgs/site-svgs.component';
import { IAmenity } from '@curbnturf/entities';
import {
  amenityFormBuilder,
  DisplayValidationErrorsContainerDirective,
  DisplayValidationErrorsDirective,
} from '@curbnturf/form-helpers';
import { ParkingValidator } from '@curbnturf/host-forms';
import { WheelchairInputComponent } from '../wheelchair-input/wheelchair-input.component';

@Component({
  selector: 'curbnturf-listing-accommodations',
  templateUrl: './listing-accommodations.component.html',
  styleUrls: ['./listing-accommodations.component.scss'],
  standalone: true,
  imports: [
    DisplayValidationErrorsDirective,
    DisplayValidationErrorsContainerDirective,
    FormsModule,
    NgIf,
    NgClass,
    ReactiveFormsModule,
    SiteSvgsComponent,
    WheelchairInputComponent,
  ],
})
export class ListingAccommodationsComponent {
  ParkingValidator = ParkingValidator;

  @Input() siteForm: UntypedFormGroup;
  @Input() editView: boolean = false;

  parkingError: string | undefined;
  guestNumberError: string | undefined;

  get amenities() {
    return this.siteForm.get('amenities') as UntypedFormArray;
  }

  get maxGuests() {
    if (this.siteForm) {
      return this.siteForm.get('maxGuests') as FormControl<number | null>;
    }

    return;
  }

  get maxHeight() {
    if (this.siteForm) {
      return this.siteForm.get('maxHeight') as FormControl<number | null>;
    }

    return;
  }

  get maxWidth() {
    if (this.siteForm) {
      return this.siteForm.get('maxWidth') as FormControl<number | null>;
    }

    return;
  }

  get maxLength() {
    if (this.siteForm) {
      return this.siteForm.get('maxLength') as FormControl<number | null>;
    }

    return;
  }

  constructor(private fb: FormBuilder) {}

  selected(amenityType: IAmenity['type']): boolean {
    if (!this.amenities) {
      return false;
    }

    const amenities = this.amenities.value.map((amenity: IAmenity) => amenity.type);

    return amenities.includes(amenityType);
  }

  select(amenityType: IAmenity['type']) {
    if (this.amenities) {
      const amenities = this.amenities.value.map((amenity: IAmenity) => amenity.type);
      if (amenities.indexOf(amenityType) !== -1) {
        return;
      } else {
        if (amenityType === 'pullThrough') {
          const index = amenities.indexOf('backIn');
          this.amenities.removeAt(index);
        } else {
          const index = amenities.indexOf('pullThrough');
          this.amenities.removeAt(index);
        }
        this.amenities.push(amenityFormBuilder(this.fb, { type: amenityType }));

        this.siteForm.markAsDirty();
      }
    }
  }

  public validate() {
    if (ParkingValidator(this.amenities)?.invalidParking) {
      this.parkingError = 'How can a guest park at the site?';
    } else {
      this.parkingError = undefined;
    }
    if (this.maxGuests?.value === undefined || this.maxGuests?.value === null || !(this.maxGuests?.value >= 1)) {
      this.guestNumberError = 'You probably should allow at least one guest!';
    } else {
      this.guestNumberError = undefined;
    }
  }
}
